import { render, staticRenderFns } from "./AppBarThemeSwitcher.vue?vue&type=template&id=8fb7cfe4&"
import script from "./AppBarThemeSwitcher.vue?vue&type=script&lang=js&"
export * from "./AppBarThemeSwitcher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFadeTransition } from 'vuetify/lib/components/transitions';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VFadeTransition,VIcon})
